// Environment configuration - single source of truth for environment variables

export type EleosEnvironment = 'prod' | 'dev' | 'localhost';

// Current environment from build-time variable
export const ELEOS_ENV: EleosEnvironment = import.meta.env.VITE_APP_ENV as EleosEnvironment || 'localhost';

export const API_SERVER = import.meta.env.VITE_HOST_CONTROLLER;

export const AUTH0_CONFIG = {
    domain: import.meta.env.VITE_AUTH0_DOMAIN,
    clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
    audience: import.meta.env.VITE_AUTH0_AUDIENCE,
    scope: ["openid", "profile", "email", "offline_access"],
    redirectUri: window.location.origin,
}

export const SENTRY_CONFIG = {
    dsn: import.meta.env.VITE_SENTRY_DSN,
}
